import AdSettings from "../../components/admin/settings/Settings";

const AdminSettings = () => {
return <AdSettings/>
};

export default AdminSettings;